const toggleShopBrands = () => {
    var $fba = $('.featured-brands-area'),

        slideUpFeaturedBrands = function() {
            $fba.toggle().toggleClass('animated').css('bottom', '40px');
        };

    $('#toggleShopBrands').on('click', function() {
        $(this).children().toggleClass('fa-angle-down');
        slideUpFeaturedBrands();
    });

    $('#close-featured-brands').on('click', function() {
        $('#toggleShopBrands i').toggleClass('fa-angle-down');
        $fba.hide().removeClass('animated').css('bottom', '0');
    });
};

export {toggleShopBrands}
